import { GAEvent } from 'tracking/events/GAEvent'

export class NavigationClickEvent extends GAEvent {
  constructor(label: string, href: string) {
    super('Navigation', 'Click', label, href)
  }
}
